import React from 'react'
import {Collection, WhenModelValue} from '@morningtrain/react-resources'
import * as Columns from 'support/columns'
import { Table } from 'widgets/crud'
import { PeriodFilter, SelectedDepartmentFilter, SupplierFilter, SwitchFilter } from 'support/filters'
import { Translation } from '@morningtrain/react-translations'
import { Link } from '@morningtrain/react-navigation'
import { SquareButton } from 'ui/buttons'
import * as Icons from 'ui/icons'
import { PaginationFilter, WhenConstraint } from '@morningtrain/react-filters'
import * as UI from 'ui'
import {useCookies} from "react-cookie";
import moment from "moment/moment";
import UpdateCookieOnChange from "support/utilities/UpdateCookieOnChange";

export default function Orders () {
  let defaultPeriod = {
    from: moment().startOf('week').format('YYYY-MM-DD'),
    to: moment().endOf('week').format('YYYY-MM-DD')
  }
  // let period1 = defaultPeriod;
  let period2 = defaultPeriod;

  // const cookieNameFirst = 'page.filters.orderedAt';
  const cookieNameSecond = 'page.filters.expectedDelivery';
  const [cookies] = useCookies([cookieNameSecond]);//cookieNameFirst,

  // if (cookies[cookieNameFirst] !== undefined) {
  //   period1 = cookies[cookieNameFirst];
  // }

  if (cookies[cookieNameSecond] !== undefined) {
    period2 = cookies[cookieNameSecond];
  }

  let x = true;
  return (
    <UI.Card>
      <Collection resourceName='inventory.order' operationContext='completed_orders'>
        <SelectedDepartmentFilter />

        <UI.CardHeader>
          <UI.SecondaryHeading width=''>
            <Translation name='inventory.delivery.title' />
          </UI.SecondaryHeading>
          <SwitchFilter
            enum='order_delivery_note_status'
            name='status'
            defaultValue='completed'
            only={['completed', 'received', 'unhandled']}
            isFrontTranslated={true}
            translationKey='enums.order_delivery_note_status'
          />
        </UI.CardHeader>

        <UI.TableHeader>
          <UI.FlexGrid cols={1} responsive={{ sm: 2, lg: 3 }} className='w-full'>
            <SupplierFilter />
            <WhenConstraint name='status' matches='unhandled' negate>
              {/*<UpdateCookieOnChange name={cookieNameFirst}>*/}
              {/*  <PeriodFilter defaultValue={period1} name='ordered_at' label={<Translation name='columns.ordered_at' />} />*/}
              {/*</UpdateCookieOnChange>*/}
              <UpdateCookieOnChange name={cookieNameSecond}>
                <PeriodFilter defaultValue={period2} name='order_for_end' label={<Translation name='columns.delivery_at' />} />
              </UpdateCookieOnChange>
            </WhenConstraint>
          </UI.FlexGrid>
        </UI.TableHeader>

        <Table>
          <Columns.Text name='department.name' label={<Translation name='columns.department' />} />
          <Columns.Text name='supplier.name' label={<Translation name='columns.supplier' />} />
          <Columns.Date name='ordered_at' label={<Translation name='columns.ordered_at' />} />
          <Columns.Date name='order_for_start' label={<Translation name='columns.delivery_at' />} />
          <WhenModelValue name="received_later" condition={true}>
            <Columns.Date
                name='received_at'
                label={<Translation name='columns.received_at' />}
                rowClass={'text-red-500'}
            />
          </WhenModelValue>
          <WhenModelValue name="received_later" condition={false}>
            <Columns.Date
                name='received_at'
                label={<Translation name='columns.received_at' />}
            />
          </WhenModelValue>
          <WhenModelValue name="received_later" negate>
            <Columns.Date
              name='received_at'
              label={<Translation name='columns.received_at' />}
            />
          </WhenModelValue>

          <Columns.Currency name='total_price' alignment='right' label={<Translation name='columns.total_price' />} />
          <Columns.Column alignment='right'>
            <Link route='app.inventory.order.edit' parameters={{ inventory_order: 'model:id', inventory_supplier: 'model:supplier_id' }}>
              <SquareButton color='btn-lightgray'>
                <Icons.Pencil className='w-4 h-4' />
              </SquareButton>
            </Link>
          </Columns.Column>
        </Table>

        <PaginationFilter />

      </Collection>
    </UI.Card>
  )
}
